import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  actions: {
  	loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/instructors`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/instructors/page`, { params: pagination })
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/instructors/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('delete', payload)
      return Vue.axios.delete(`${config.serverURI}/instructors/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/instructor.js